import { Box } from '@mui/material';
import React, { useState } from 'react';
import SwipeableDrawer from '../../../SwipeableDrawer';
import NavIcon from '../../SideNavbar/NavIcon';
import SearchBar from '../../../SearchBar/SearchBar';

const containerStyles = {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
};

const MobileTopBar: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <Box sx={containerStyles}>
      <NavIcon icon='searchNormal' onClick={() => setIsDrawerOpen(true)} />
      <SwipeableDrawer open={isDrawerOpen} onClose={handleCloseDrawer}>
        <SearchBar closeDrawer={handleCloseDrawer} />
      </SwipeableDrawer>
    </Box>
  );
};

export default MobileTopBar;
